import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface WhiteboardsKeyType {
  canNotDeterminatePage: LocalesKey;
  changesWontBeSavedUntilTheConnectionIsRestoredPleaseWaitAMomentWhileWeTryToReconnect: LocalesKey;
  comments: LocalesKey;
  commentTagComposition: LocalesKey;
  commentTagDefault: LocalesKey;
  commentTagGeometry: LocalesKey;
  commentTagLighting: LocalesKey;
  commentTagMaterial: LocalesKey;
  commentTagTexture: LocalesKey;
  connectionLost: LocalesKey;
  connectionLostTryingToReconnect: LocalesKey;
  connectionSuccessfullyRestored: LocalesKey;
  couldNotRestoreTheConnection: LocalesKey;
  couldNotLoadWhiteboard: LocalesKey;
  createMissingShapes: LocalesKey;
  deleteEvents: LocalesKey;
  draftCommentIsNotVisibleToOtherProjectMembersUntilItIsPublished: LocalesKey;
  draftCommentNotVisibleToOthers: LocalesKey;
  draftCommentsNotVisibleToOthers: LocalesKey;
  addFileNamesAboveEachImage: LocalesKey;
  filterComments: LocalesKey;
  goTo: LocalesKey;
  goToWhiteboardAfterSending: LocalesKey;
  imageAlreadyAttachedToThisTask: LocalesKey;
  inProgress: LocalesKey;
  limits: LocalesKey;
  markAsInProgress: LocalesKey;
  markAsResolved: LocalesKey;
  markAsUnresolved: LocalesKey;
  newImagesVisibility: LocalesKey;
  noCommentsFound: LocalesKey;
  open: LocalesKey;
  page: LocalesKey;
  pageName: LocalesKey;
  pagesOnThisWhiteboard: LocalesKey;
  pleaseSelectAnImage: LocalesKey;
  preview: LocalesKey;
  project: LocalesKey;
  publishAll: LocalesKey;
  publishedCommentIsVisibleToAllProjectMembers: LocalesKey;
  records: LocalesKey;
  resolved: LocalesKey;
  rootProjectWhiteboard: LocalesKey;
  saveDraft: LocalesKey;
  select: LocalesKey;
  selectPage: LocalesKey;
  sendAndStay: LocalesKey;
  setInProgress: LocalesKey;
  shapesOnThisPage: LocalesKey;
  showInProgressComments: LocalesKey;
  showResolvedComments: LocalesKey;
  sendToTask: LocalesKey;
  sentToWhiteboard: LocalesKey;
  shapes: LocalesKey;
  singularLowerCase: LocalesKey;
  task: LocalesKey;
  thereIsNoMissingShapes: LocalesKey;
  unsetInProgress: LocalesKey;
  updateEventDate: LocalesKey;
  youHaveUsedAllPagesQuota: LocalesKey;
  youHaveUsedAllShapesQuota: LocalesKey;
  whiteboardBackups: LocalesKey;
  whiteboardComments: LocalesKey;
  whiteboardDeleteEvents: LocalesKey;
  whiteboardImages: LocalesKey;
  whiteboardIsExportingToPdf: LocalesKey;
  whiteboardRoomFull: LocalesKey;
  wouldYouLikeToBeRedirectedToTheWhiteboard: LocalesKey;
  zoomIn: LocalesKey;
  zoomOut: LocalesKey;
  zoomTo100: LocalesKey;
  zoomToFit: LocalesKey;
  zoomToSelection: LocalesKey;
}

export const whiteboardsKeys = keyPathMirror<WhiteboardsKeyType, string>(
  {
    canNotDeterminatePage: null,
    changesWontBeSavedUntilTheConnectionIsRestoredPleaseWaitAMomentWhileWeTryToReconnect:
      null,
    comments: null,
    commentTagComposition: null,
    commentTagDefault: null,
    commentTagGeometry: null,
    commentTagLighting: null,
    commentTagMaterial: null,
    commentTagTexture: null,
    connectionLost: null,
    connectionLostTryingToReconnect: null,
    connectionSuccessfullyRestored: null,
    couldNotRestoreTheConnection: null,
    couldNotLoadWhiteboard: null,
    createMissingShapes: null,
    deleteEvents: null,
    draftCommentIsNotVisibleToOtherProjectMembersUntilItIsPublished: null,
    draftCommentNotVisibleToOthers: null,
    draftCommentsNotVisibleToOthers: null,
    addFileNamesAboveEachImage: null,
    filterComments: null,
    goTo: null,
    goToWhiteboardAfterSending: null,
    imageAlreadyAttachedToThisTask: null,
    inProgress: null,
    limits: null,
    markAsInProgress: null,
    markAsResolved: null,
    markAsUnresolved: null,
    newImagesVisibility: null,
    noCommentsFound: null,
    open: null,
    page: null,
    pageName: null,
    pagesOnThisWhiteboard: null,
    pleaseSelectAnImage: null,
    preview: null,
    project: null,
    publishAll: null,
    publishedCommentIsVisibleToAllProjectMembers: null,
    records: null,
    resolved: null,
    rootProjectWhiteboard: null,
    saveDraft: null,
    select: null,
    selectPage: null,
    sendAndStay: null,
    setInProgress: null,
    shapesOnThisPage: null,
    showInProgressComments: null,
    showResolvedComments: null,
    sendToTask: null,
    sentToWhiteboard: null,
    shapes: null,
    singularLowerCase: null,
    task: null,
    thereIsNoMissingShapes: null,
    unsetInProgress: null,
    updateEventDate: null,
    youHaveUsedAllPagesQuota: null,
    youHaveUsedAllShapesQuota: null,
    whiteboardBackups: null,
    whiteboardComments: null,
    whiteboardDeleteEvents: null,
    whiteboardImages: null,
    whiteboardIsExportingToPdf: null,
    whiteboardRoomFull: null,
    wouldYouLikeToBeRedirectedToTheWhiteboard: null,
    zoomIn: null,
    zoomOut: null,
    zoomTo100: null,
    zoomToFit: null,
    zoomToSelection: null
  },
  'models.whiteboards.'
);
